export default "__VITE_PUBLIC_ASSET__841d8493__"